module.exports = __webpack_public_path__ + "static/media/CN.151979c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CN.svg
// module id = 227
// module chunks = 0